<div style="padding-left:1em; padding-bottom:1em">

     <!-- <div><button class="btn-back" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>-->

     <h1 class="page-title" translate>{{'FAQ.page_title'}}</h1>
      <!--  ***** General Information about Newborn Registration Service Start ****  -->

     <accordion #acc_01 label="FAQ.general_information" outer-class="bottom-margin">

      <accordion #acc_02 label="FAQ.what_is_nrs.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.what_is_nrs.text'></div>
            <ul class="servie-list">
                  <li [innerHTML]="'FAQ.what_is_nrs.li_1' | translate"></li>
                  <li [innerHTML]="'FAQ.what_is_nrs.li_2' | translate"></li>
                  <li [innerHTML]="'FAQ.what_is_nrs.li_3' | translate"></li>
            </ul>
      </accordion>

      <accordion #acc_03 label="FAQ.things_you_need.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.things_you_need.text_1'></div>
            <div class="page-title" translate='FAQ.things_you_need.text_2'></div>
            <ul class="servie-list">
                  <li translate='FAQ.things_you_need.li_1'></li>
                  <li translate='FAQ.things_you_need.li_2'></li>
                  <li translate='FAQ.things_you_need.li_3'></li>
                  <li translate='FAQ.things_you_need.li_4'></li>
                  <li translate='FAQ.things_you_need.li_5'></li>
                  <li translate='FAQ.things_you_need.li_6'></li>
                  <li translate='FAQ.things_you_need.li_7_1'>
                  <a-link link-url="FAQ.things_you_need.li_7_link"
                      alt-text="FAQ.things_you_need.li_7_alt"
                      label='FAQ.things_you_need.li_7_label'>
                  </a-link>
                  <span translate='FAQ.things_you_need.li_7_2'></span>
                  </li>
            </ul>
            <div class="page-title" translate='FAQ.things_you_need.text_3'></div>
            <ul class="servie-list">
                  <li translate='FAQ.things_you_need.li_8'></li>
                  <li translate='FAQ.things_you_need.li_9'></li>
                  <li translate='FAQ.things_you_need.li_10'></li>
                  <li translate='FAQ.things_you_need.li_11'></li>
                  <li translate='FAQ.things_you_need.li_12'></li>
            </ul>
            <div class="page-title" translate='FAQ.things_you_need.note'></div>
            <div style="margin-top: 0.6em;" class="page-title" translate='FAQ.things_you_need.text_4'></div>
            <div class="page-title" translate='FAQ.things_you_need.text_5'></div>
            <div class="page-title" translate='FAQ.things_you_need.text_6'></div>
            <div class="page-title" translate='FAQ.things_you_need.text_7_1'>
            <a-link link-url="FAQ.things_you_need.text_7_link"
                    alt-text="FAQ.things_you_need.text_7_alt"
                    label='FAQ.things_you_need.text_7_label'>
            </a-link>
            <span translate='FAQ.things_you_need.text_7_2'></span>
            </div>
            <div class="page-title" translate='FAQ.things_you_need.text_8'></div>
            <div class="page-title" translate='FAQ.things_you_need.text_9'></div>
      </accordion>
      </accordion>
      <!--  ***** General Information about Newborn Registration Service End ****  -->
      <!--  ***** Birth Registration Start ****  -->


      <accordion #acc_04 label="FAQ.birth_registration"  outer-class="bottom-margin">
      <accordion #acc_05 label="FAQ.what_is_br.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.what_is_br.text_1'></div>
            <ul class="servie-list">
                  <li translate='FAQ.what_is_br.li_1'></li>
                  <li translate='FAQ.what_is_br.li_2'></li>
            </ul>
            <div class="page-title" translate='FAQ.what_is_br.text_2'></div>
      </accordion>

      <accordion #acc_06 label="FAQ.register_online.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.register_online.text_1'></div>
            <ul class="servie-list">
                  <li translate='FAQ.register_online.li_1'></li>
                  <li translate='FAQ.register_online.li_2_1'>
                        <a-link link-url="FAQ.register_online.li_2_link"
                            alt-text="FAQ.register_online.li_2_alt"
                            label='FAQ.register_online.li_2_label'>
                        </a-link>
                  <span translate='FAQ.register_online.li_2_2'></span>
                  <li translate='FAQ.register_online.li_3_1'>
                        <a-link link-url="FAQ.register_online.li_3_link"
                            alt-text="FAQ.register_online.li_3_alt"
                            label='FAQ.register_online.li_3_label'>
                        </a-link>
                  <span translate='FAQ.register_online.li_3_2'></span>
                  </li>
                  <li translate='FAQ.register_online.li_4'></li>
            </ul>
            <span class="page-title" translate='FAQ.register_online.text_2_1'></span>
                  <a-link link-url="FAQ.register_online.text_2_link"
                      alt-text="FAQ.register_online.text_2_alt"
                      label='FAQ.register_online.text_2_label'>
                  </a-link>
            <span translate='FAQ.register_online.text_2_2'></span>
            <div class="page-title" style="margin-top:1em;" translate='FAQ.register_online.note'></div>
      </accordion>
      <div id="whoCanBeListed">
      <accordion #acc_07 label="FAQ.who_can_be_listed.title"  outer-class="bottom-margin" [(open)]="whoCanBeListed">
            <div class="page-title" translate='FAQ.who_can_be_listed.text_1'></div>
            <ul class="servie-list">
                  <li translate='FAQ.who_can_be_listed.li_1'></li>
                  <li translate='FAQ.who_can_be_listed.li_2'></li>
                  <li translate='FAQ.who_can_be_listed.li_3'></li>
                  <li translate='FAQ.who_can_be_listed.li_4'></li>
                  <li translate='FAQ.who_can_be_listed.li_5'></li>
            </ul>
            <div class="page-title" translate='FAQ.who_can_be_listed.text_2'></div>
      </accordion>
      </div>
      <accordion #acc_08 label="FAQ.who_can_register.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.who_can_register.text_1_1'>
            <a-link (click)="linkOnSamePage('whoCanBeListed',$event)"
                  alt-text="FAQ.who_can_register.text_1_alt"
                  label='FAQ.who_can_register.text_1_label'>
            </a-link>
            <span translate='FAQ.who_can_register.text_1_2'></span>
            </div>
            <div class="page-title" translate='FAQ.who_can_register.text_2_1'>
            <a routerLink='/ORG_contact_information' (click)="closeLightbox()" 
                        alt-text='FAQ.alt_reg_gen'
                        translate='FAQ.label_reg_gen'></a>
            <span translate='FAQ.who_can_register.text_2_2'></span>
             </div>
     </accordion>

     <accordion #acc_09 label="FAQ.when_registered.title"  outer-class="bottom-margin">
            <div class="page-title" [innerHTML]="'FAQ.when_registered.text_1' | translate"></div>
            <div class="page-title" translate='FAQ.when_registered.text_2'>
            <a routerLink='/ORG_contact_information' 
                  (click)="closeLightbox()"
                  alt-text='FAQ.alt_reg_gen'
                  translate='FAQ.label_reg_gen'></a><span>.</span>
            </div>
     </accordion>

     <accordion #acc_10 label="FAQ.one_year_or_older.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.one_year_or_older.text'>
            <a  routerLink='/ORG_contact_information' 
                  (click)="closeLightbox()"
                  alt-text='FAQ.alt_reg_gen'
                  translate='FAQ.label_reg_gen'></a><span>.</span>
            </div>
      </accordion>

      <accordion #acc_11 label="FAQ.why_should_i_use.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.why_should_i_use.text'></div>
      </accordion>

      <accordion #acc_12 label="FAQ.what_is_the_difference.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.what_is_the_difference.text'></div>
      </accordion>

      <accordion #acc_13 label="FAQ.how_long.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.how_long.text'></div>
      </accordion>

      <accordion #acc_14 label="FAQ.is_there_a_fee.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.is_there_a_fee.text_1_1'>
                  <a-link (click)="linkOnSamePage('whatAreTheFee', $event)"
                        alt-text="FAQ.is_there_a_fee.text_1_alt"
                        label='FAQ.is_there_a_fee.text_1_label'>
                  </a-link>
            <span translate='FAQ.is_there_a_fee.text_1_2'></span>
            </div>
            <div class="page-title" translate='FAQ.is_there_a_fee.text_2'></div>
            <div class="page-title" translate='FAQ.is_there_a_fee.text_3_1'>
                  <a routerLink='/ORG_contact_information' 
                        (click)="closeLightbox()"
                        alt-text='FAQ.alt_reg_gen'
                        translate='FAQ.label_reg_gen'></a>
            <span translate='FAQ.is_there_a_fee.text_3_2'></span>
            </div>
      </accordion>

      <accordion #acc_15 label="FAQ.can_i_submit.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.can_i_submit.text'></div>
      </accordion>

      <accordion #acc_16 label="FAQ.register_single_name.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.register_single_name.text_1_1'>
                  <a-link link-url="FAQ.register_single_name.text_13_link"
                        alt-text="FAQ.register_single_name.text_13_alt"
                        label='FAQ.register_single_name.text_13_label'>
                  </a-link>
            <span translate='FAQ.register_single_name.text_1_2'></span>
            </div>
            <div class="page-title" translate='FAQ.register_single_name.text_2'></div>
            <ul class="servie-list">
                  <li translate='FAQ.register_single_name.li_1'></li>
                  <li translate='FAQ.register_single_name.li_2'></li>
                  <li translate='FAQ.register_single_name.li_3'></li>
            </ul>
            <div class="page-title" translate='FAQ.register_single_name.text_3_1'>
                  <a-link link-url="FAQ.register_single_name.text_13_link"
                        alt-text="FAQ.register_single_name.text_13_alt"
                        label='FAQ.register_single_name.text_13_label'>
                  </a-link>
            <span translate='FAQ.register_single_name.text_3_2'></span>
            </div>
      </accordion>

      <accordion #acc_17 label="FAQ.register_surrogacy.title"  outer-class="bottom-margin">
            <div class="page-title" [innerHTML]="'FAQ.register_surrogacy.text_1' | translate"></div>
            <div class="page-title" translate='FAQ.register_surrogacy.text_2'></div>
            <ul class="servie-list">
                  <li><a-link link-url="FAQ.register_surrogacy.sur_link"
                              alt-text="FAQ.register_surrogacy.sur_alt"
                              label='FAQ.register_surrogacy.sur_label'>
                        </a-link></li>
                  <li><a-link link-url="FAQ.register_surrogacy.ip_link"
                              alt-text="FAQ.register_surrogacy.ip_alt"
                              label='FAQ.register_surrogacy.ip_label'>
                        </a-link></li>
            </ul>
      </accordion>

      <accordion #acc_18 label="FAQ.letters_with_accents.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.letters_with_accents.text'></div>

            <div class="div-table">
                  <div class="div-table-row" colspan="2">
                        <div class="div-table-header">
                              <strong translate='FAQ.letters_with_accents.character'></strong>
                  </div>
                        <div class="div-table-header2">
                              <strong translate='FAQ.letters_with_accents.press_alt'></strong>
                  </div>
                    </div>
                  <div class="div-table-row">
                      <div class="div-table-col">à</div>
                      <div class="div-table-col2">133</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">â</div>
                        <div class="div-table-col2">131</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">ä</div>
                        <div class="div-table-col2">132</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">ç</div>
                        <div class="div-table-col2">135</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">Ç</div>
                        <div class="div-table-col2">128</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">é</div>
                        <div class="div-table-col2">130</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">É</div>
                        <div class="div-table-col2">144</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">è</div>
                        <div class="div-table-col2">138</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">ê</div>
                        <div class="div-table-col2">136</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">ë</div>
                        <div class="div-table-col2">137</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">î</div>
                        <div class="div-table-col2">140</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">ï</div>
                        <div class="div-table-col2">139</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">ô</div>
                        <div class="div-table-col2">147</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">ö</div>
                        <div class="div-table-col2">148</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">ù</div>
                        <div class="div-table-col2">151</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">û</div>
                        <div class="div-table-col2">150</div>
                  </div>
                  <div class="div-table-row">
                        <div class="div-table-col">ü</div>
                        <div class="div-table-col2">129</div>
                  </div>
            </div>
      </accordion>
      </accordion>
      <!--  ***** Birth Registration End ****  -->
      <!--  ***** Birth Certificate Start ****  -->

      <accordion #acc_19 label="FAQ.birth_certificate"  outer-class="bottom-margin"  id="birthCertificate" [(open)]="birthCertificate">
      <div id="whatIsBCFaq">
      <accordion #acc_20 label="FAQ.what_is_bc.title"  outer-class="bottom-margin" [(open)]="whatIsBCFaq">
            <div class="page-title" translate='FAQ.what_is_bc.text_1'></div>
            <div class="page-title" translate='FAQ.what_is_bc.text_2_1'>
                  <a-link link-url="FAQ.what_is_bc.text_2_link"
                        alt-text="FAQ.what_is_bc.text_2_alt"
                        label='FAQ.what_is_bc.text_2_label'>
                  </a-link>
            <span translate='FAQ.what_is_bc.text_2_2'></span>
            </div>
            <div class="page-title" translate='FAQ.what_is_bc.text_3'></div>
            <div class="page-title" [innerHTML]="'FAQ.what_is_bc.text_4' | translate"></div>
            <div class="page-title" [innerHTML]="'FAQ.what_is_bc.note_1' | translate"></div>
            <div class="page-title" style="margin-top: 0.6em; margin-bottom: 0.6em;" translate='FAQ.what_is_bc.text_5'></div>
            <div class="page-title" style="text-align: center;">
                  <a-link link-url="FAQ.what_is_bc.sample_1_link"
                        alt-text="FAQ.what_is_bc.sample_1_alt"
                        label='FAQ.what_is_bc.sample_1_label'>
                  </a-link>
            </div>
            <div class="page-title" style="margin-top:1em;" [innerHTML]="'FAQ.what_is_bc.text_6' | translate"></div>
            <ul class="servie-list">
                  <li translate='FAQ.what_is_bc.li_1'></li>
                  <li translate='FAQ.what_is_bc.li_2'></li>
                  <li translate='FAQ.what_is_bc.li_3'></li>
                  <li translate='FAQ.what_is_bc.li_4'></li>
                  <li translate='FAQ.what_is_bc.li_5'></li>
                  <li translate='FAQ.what_is_bc.li_6'></li>
                  <li translate='FAQ.what_is_bc.li_7'></li>
                  <li translate='FAQ.what_is_bc.li_8'></li>
                  <li translate='FAQ.what_is_bc.li_9'></li>
                  <li translate='FAQ.what_is_bc.li_10'></li>
            </ul>
            <div class="page-title" translate='FAQ.what_is_bc.note_2'></div>
            <div class="page-title" translate='FAQ.what_is_bc.text_7'></div>
            <ul class="servie-list" style="list-style: none;">
                  <li class="checkmark" [innerHTML]="'FAQ.what_is_bc.li_11'| translate"></li>
                  <li class="checkmark" [innerHTML]="'FAQ.what_is_bc.li_12'| translate"></li>
                  <li class="checkmark" translate='FAQ.what_is_bc.li_13'></li>
            </ul>
            <div class="page-title" style="text-align: center;">
                  <a-link link-url="FAQ.what_is_bc.sample_2_link"
                        alt-text="FAQ.what_is_bc.sample_2_alt"
                        label='FAQ.what_is_bc.sample_2_label'>
                  </a-link>
            </div>
            <div class="page-title" style="margin-top:1em;" [innerHTML]="'FAQ.what_is_bc.text_8' | translate"></div>
            <ul class="servie-list">
                  <li translate='FAQ.what_is_bc.li_14'></li>
                  <li translate='FAQ.what_is_bc.li_15'></li>
                  <li translate='FAQ.what_is_bc.li_16'></li>
                  <li translate='FAQ.what_is_bc.li_17'></li>
                  <li translate='FAQ.what_is_bc.li_18'></li>
                  <li translate='FAQ.what_is_bc.li_19'></li>
                  <li translate='FAQ.what_is_bc.li_20'></li>
                  <li translate='FAQ.what_is_bc.li_21'></li>
            </ul>
            <div class="page-title" [innerHTML]="'FAQ.what_is_bc.text_9' | translate"></div>
            <ul class="servie-list" style="list-style: none;">
                  <li class="checkmark" translate='FAQ.what_is_bc.li_22'></li>
                  <li class="checkmark" translate='FAQ.what_is_bc.li_23'></li>
                  <li class="checkmark" translate='FAQ.what_is_bc.li_24'></li>
                  <li class="checkmark" translate='FAQ.what_is_bc.li_25'></li>
            </ul>
            <div class="page-title" [innerHTML]="'FAQ.what_is_bc.text_10' | translate"></div>
            <ul class="servie-list">
                  <li translate='FAQ.what_is_bc.li_26'></li>
                  <li translate='FAQ.what_is_bc.li_27'></li>
                  <li translate='FAQ.what_is_bc.li_28'></li>
                  <li translate='FAQ.what_is_bc.li_29'></li>
                  <li translate='FAQ.what_is_bc.li_30'></li>
                  <li translate='FAQ.what_is_bc.li_31'></li>
                  <li translate='FAQ.what_is_bc.li_32'></li>
                  <li translate='FAQ.what_is_bc.li_33'></li>
                  <li translate='FAQ.what_is_bc.li_34'></li>
                  <li translate='FAQ.what_is_bc.li_35'></li>
                  <li translate='FAQ.what_is_bc.li_36'></li>
                  <li translate='FAQ.what_is_bc.li_37'></li>
                  <li translate='FAQ.what_is_bc.li_38'></li>
                  <li translate='FAQ.what_is_bc.li_39'></li>
                  <li translate='FAQ.what_is_bc.li_40'></li>
                  <li translate='FAQ.what_is_bc.li_41'></li>
                  <li translate='FAQ.what_is_bc.li_42'></li>
            </ul>
            <div class="page-title" translate='FAQ.what_is_bc.text_11'></div>
            <div class="page-title" translate='FAQ.what_is_bc.text_12'></div>
            <ul class="servie-list" style="list-style: none;">
                  <li class="checkmark" translate='FAQ.what_is_bc.li_43'></li>
                  <li class="checkmark" translate='FAQ.what_is_bc.li_44'></li>
                  <li class="checkmark" translate='FAQ.what_is_bc.li_45'></li>
                  <li class="checkmark" translate='FAQ.what_is_bc.li_46'></li>
            </ul>
            <div class="page-title" translate='FAQ.what_is_bc.text_13'></div>
      </accordion>
      </div>

      <accordion #acc_21 label="FAQ.why_should_i_use_bc.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.why_should_i_use_bc.text'></div>
      </accordion>
      
      <accordion #acc_22 label="FAQ.who_is_eligible.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.who_is_eligible.text_1'></div>
            <ul class="servie-list">
                  <li translate='FAQ.who_is_eligible.li_1'></li>
                  <li translate='FAQ.who_is_eligible.li_2'></li>
                  <li translate='FAQ.who_is_eligible.li_3'></li>
            </ul>
            <div class="page-title" translate='FAQ.who_is_eligible.text_2_1'>
                  <a routerLink='/ORG_contact_information' 
                        (click)="closeLightbox()"
                        alt-text='FAQ.alt_reg_gen'
                        translate='FAQ.label_reg_gen'></a>
            <span translate='FAQ.who_is_eligible.text_2_2'></span>
            </div>
            <div class="page-title" translate='FAQ.who_is_eligible.text_3'>
                  <a-link link-url="FAQ.who_is_eligible.text_3_link"
                        alt-text="FAQ.who_is_eligible.text_3_alt"
                        label='FAQ.who_is_eligible.text_3_label'>
                  </a-link><span>.</span>
            </div>
      </accordion>

      <accordion #acc_23 label="FAQ.how_can_i_apply.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.how_can_i_apply.text'></div>
      </accordion>
      <div id="whatAreTheFee">
      <accordion #acc_24 label="FAQ.what_are_the_fees.title"  outer-class="bottom-margin" [(open)]="whatAreTheFee">
            <div class="page-title" translate='FAQ.what_are_the_fees.text'></div>
      </accordion>
      </div>
      <accordion #acc_25 label="FAQ.how_can_i_pay.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.how_can_i_pay.text'></div>
      </accordion>

      <accordion #acc_26 label="FAQ.bc_eligible.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.bc_eligible.text'></div>
      </accordion>

      <accordion #acc_27 label="FAQ.how_can_i_get_bc.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.how_can_i_get_bc.text'></div>
      </accordion>

      <accordion #acc_28 label="FAQ.how_long_bc.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.how_long_bc.text'></div>
      </accordion>

      <accordion #acc_29 label="FAQ.check_the_status.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.check_the_status.text_1_1'>
                  <a-link link-url="FAQ.check_the_status.text_1_link"
                        alt-text="FAQ.check_the_status.text_1_alt"
                        label='FAQ.check_the_status.text_1_label'>
                  </a-link>
            <span translate='FAQ.check_the_status.text_1_2'></span>
            </div>
      </accordion>

      <accordion #acc_30 label="FAQ.bc_information.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.bc_information.text'></div>
      </accordion>

      <accordion #acc_31 label="FAQ.already_registered.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.already_registered.text'>
                  <a-link link-url="FAQ.already_registered.text_link"
                        alt-text="FAQ.already_registered.text_alt"
                        label='FAQ.already_registered.text_label'>
                  </a-link><span>.</span>
            </div>
      </accordion>

      <accordion #acc_32 label="FAQ.if_one_year_or_older.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.if_one_year_or_older.text'>
                  <a-link link-url="FAQ.if_one_year_or_older.text_link"
                        alt-text="FAQ.if_one_year_or_older.text_alt"
                        label='FAQ.if_one_year_or_older.text_label'>
                  </a-link><span>.</span>
            </div>
      </accordion>

      <accordion #acc_33 label="FAQ.planning_to_move.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.planning_to_move.text'></div>
      </accordion>
      </accordion>
      <!--  ***** Birth Certificate End ****  -->
      <!--  ***** Canada Child Benefits Start ****  -->
      <div id="faqCCB">
      <accordion #acc_34 label="FAQ.canada_child_benefits"  outer-class="bottom-margin"  [(open)]="faqCCB">
      <accordion #acc_35 label="FAQ.what_benefits.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.what_benefits.text'></div>
      </accordion>

      <accordion #acc_36 label="FAQ.who_can_use.title"  outer-class="bottom-margin">
            <div class="page-title" [innerHTML]="'FAQ.who_can_use.text_1' | translate">></div>
            <div class="page-title" [innerHTML]="'FAQ.who_can_use.text_2' | translate">></div>
            <div class="page-title" translate='FAQ.who_can_use.note'></div>
            <div class="page-title" translate='FAQ.who_can_use.text_3_1'>
                  <a-link link-url="FAQ.who_can_use.text_3_link"
                        alt-text="FAQ.who_can_use.text_3_alt"
                        label='FAQ.who_can_use.text_3_label'>
                  </a-link>
            <span translate='FAQ.who_can_use.text_3_2'></span>
            </div>
      </accordion>

      <accordion #acc_37 label="FAQ.use_this_service.title"  outer-class="bottom-margin">
            <div class="page-title" [innerHTML]="'FAQ.use_this_service.text' | translate"></div>
      </accordion>

      <accordion #acc_38 label="FAQ.if_i_choose.title"  outer-class="bottom-margin">
            <div class="page-title" [innerHTML]="'FAQ.if_i_choose.text_1' | translate"></div>
            <div class="page-title" translate='FAQ.if_i_choose.text_2'></div>
      </accordion>

      <accordion #acc_39 label="FAQ.primary_caregiver.title"  outer-class="bottom-margin">
            <span class="page-title" translate='FAQ.primary_caregiver.text_1'></span>
            <span class="page-title" translate='FAQ.primary_caregiver.text_2_1'></span>
                  <a-link link-url="FAQ.primary_caregiver.text_2_link"
                        alt-text="FAQ.primary_caregiver.text_2_alt"
                        label='FAQ.primary_caregiver.text_2_label'>
                  </a-link>
                  <span translate='FAQ.primary_caregiver.text_2_2'></span>     
      </accordion>

      <accordion #acc_40 label="FAQ.fees_associated.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.fees_associated.text'></div>
      </accordion>

      <accordion #acc_41 label="FAQ.directly_deposited.title"  outer-class="bottom-margin">
            <span class="page-title" translate='FAQ.directly_deposited.text_1_1'></span>
                  <a-link link-url="FAQ.directly_deposited.text_1_link_1"
                        alt-text="FAQ.directly_deposited.text_1_alt_1"
                        label='FAQ.directly_deposited.text_1_label_1'>
                  </a-link>
            <span class="page-title" translate='FAQ.directly_deposited.text_1_2'></span>
                  <a-link link-url="FAQ.account_link"
                        alt-text="FAQ.account_alt"
                        label='FAQ.account_label'>
                  </a-link>
                  <span translate='FAQ.directly_deposited.text_1_3'></span>     
      </accordion>

      <accordion #acc_42 label="FAQ.first_payment.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.first_payment.text'></div>
      </accordion>

      <accordion #acc_43 label="FAQ.check_status.title"  outer-class="bottom-margin">
            <span class="page-title" translate='FAQ.check_status.text_1_1'></span>
                  <a-link link-url="FAQ.account_link"
                        alt-text="FAQ.account_alt"
                        label='FAQ.account_label'>
                  </a-link>
            <span class="page-title" translate='FAQ.check_status.text_1_2'></span>
                  <a-link link-url="FAQ.benefits_link"
                        alt-text="FAQ.benefits_alt"
                        label='FAQ.benefits_label'>
                  </a-link>
                  <span translate='FAQ.check_status.text_1_3'></span>     
      </accordion>

      <accordion #acc_44 label="FAQ.application_sent.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.application_sent.text'></div>
      </accordion>

      <accordion #acc_45 label="FAQ.information_sent.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.information_sent.text'></div>
            <ul class="servie-list">
                  <li translate='FAQ.information_sent.li_1'></li>
                  <li translate='FAQ.information_sent.li_2'></li>
                  <li translate='FAQ.information_sent.li_3'></li>
            </ul>
      </accordion>

      <accordion #acc_46 label="FAQ.new_address.title"  outer-class="bottom-margin">
            <span class="page-title" translate='FAQ.new_address.text_1_1'></span>
                  <a-link link-url="FAQ.account_link"
                        alt-text="FAQ.account_alt"
                        label='FAQ.account_label'>
                  </a-link>
            <span class="page-title" translate='FAQ.new_address.text_1_2'></span>
                  <a-link link-url="FAQ.benefits_link"
                        alt-text="FAQ.benefits_alt"
                        label='FAQ.benefits_label'>
                  </a-link>
                  <span translate='FAQ.new_address.text_1_3'></span> 
      </accordion>

      <accordion #acc_47 label="FAQ.already_registered_apply.title"  outer-class="bottom-margin">
            <span class="page-title" translate='FAQ.already_registered_apply.text_1_1'></span>
                  <a-link link-url="FAQ.account_link"
                        alt-text="FAQ.account_alt"
                        label='FAQ.account_label'>
                  </a-link>
            <span class="page-title" [innerHTML]="'FAQ.already_registered_apply.text_1_2'| translate"></span>
      </accordion> 

      <accordion #acc_48 label="FAQ.over_one_year.title"  outer-class="bottom-margin">
            <span class="page-title" translate='FAQ.over_one_year.text_1_1'></span>
                  <a-link link-url="FAQ.account_link"
                        alt-text="FAQ.account_alt"
                        label='FAQ.account_label'>
                  </a-link>
            <span class="page-title" translate='FAQ.over_one_year.text_1_2'></span>
                  <a-link link-url="FAQ.over_one_year.text_1_link"
                        alt-text="FAQ.over_one_year.text_1_alt"
                        label='FAQ.over_one_year.text_1_label'>
                  </a-link>
                  <span [innerHTML]="'FAQ.over_one_year.text_1_3'| translate"></span> 
      </accordion>
      </accordion>
      </div>
      <!--  ***** Canada Child Benefits End ****  -->
      <!--  ***** SIN Start ****  -->
      <div id="faqSIN">
      <accordion #acc_49 label="FAQ.sin"  outer-class="bottom-margin" [(open)]="faqSIN">
      <accordion #acc_50 label="FAQ.what_is_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.what_is_sin.text'></div>
      </accordion>

      <accordion #acc_51 label="FAQ.service_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.service_sin.text_1'></div>
            <div class="page-title" translate='FAQ.service_sin.text_2'></div>
      </accordion>

      <accordion #acc_52 label="FAQ.eligible_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.eligible_sin.text_1'>
                  <a-link link-url="FAQ.service_link"
                        alt-text="FAQ.service_alt"
                        label='FAQ.service_label'>
                  </a-link><span>.</span>
            </div>
            <div class="page-title" translate='FAQ.eligible_sin.text_2'></div>
      </accordion>

      <accordion #acc_53 label="FAQ.fee_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.fee_sin.text'></div>
      </accordion>

      <accordion #acc_54 label="FAQ.how_long_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.how_long_sin.text'></div>
      </accordion>

      <accordion #acc_55 label="FAQ.check_status_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.check_status_sin.text'></div>
      </accordion>

      <accordion #acc_56 label="FAQ.contact_regarding_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.contact_regarding_sin.text_1_1'>
                  <a-link link-url="FAQ.service_link"
                        alt-text="FAQ.service_alt"
                        label='FAQ.service_label'>
                  </a-link>
                  <span translate='FAQ.contact_regarding_sin.text_1_2'></span>
            </div>
      </accordion>

      <accordion #acc_57 label="FAQ.application_sent_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.application_sent_sin.text'></div>
      </accordion>

      <accordion #acc_58 label="FAQ.information_sent_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.information_sent_sin.text'></div>
            <ul class="servie-list">
                  <li translate='FAQ.information_sent_sin.li_1'></li>
                  <li translate='FAQ.information_sent_sin.li_2'></li>
                  <li translate='FAQ.information_sent_sin.li_3'></li>
                  <li translate='FAQ.information_sent_sin.li_4'></li>
                  <li translate='FAQ.information_sent_sin.li_5'></li>
                  <li translate='FAQ.information_sent_sin.li_6'></li>
                  <li translate='FAQ.information_sent_sin.li_7'></li>
            </ul>
      </accordion>

      <accordion #acc_59 label="FAQ.already_registered_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.already_registered_sin.text'>
                  <a-link link-url="FAQ.service_link"
                        alt-text="FAQ.service_alt"
                        label='FAQ.service_label'>
                  </a-link><span>.</span>
       </div>
      </accordion>

      <accordion #acc_60 label="FAQ.over_one_year_sin.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.over_one_year_sin.text'>
                  <a-link link-url="FAQ.service_link"
                        alt-text="FAQ.service_alt"
                        label='FAQ.service_label'>
                  </a-link><span>.</span>
       </div>
      </accordion>

      <accordion #acc_61 label="FAQ.personal_information.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.personal_information.text'></div>
      </accordion>
      </accordion>
      </div>
      <!--  ***** SIN End ****  -->
      <!--  ***** Education Savings Referral Start ****  -->
      <div id="faqESR">
      <accordion #acc_62 label="FAQ.education_savings_referral"  outer-class="bottom-margin" [(open)]="faqESR">
      <accordion #acc_63 label="FAQ.what_is_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.what_is_resp.text_1_1'>
                  <a-link link-url="FAQ.what_is_resp.text_1_link"
                        alt-text="FAQ.what_is_resp.text_1_alt"
                        label='FAQ.what_is_resp.text_1_label'>
                  </a-link>
            <span translate='FAQ.what_is_resp.text_1_2'></span>
            </div>
            <ul class="servie-list">
                  <li translate='FAQ.what_is_resp.li_1_1'>
                  <a-link link-url="FAQ.what_is_resp.li_1_link_1"
                        alt-text="FAQ.what_is_resp.li_1_alt_1"
                        label='FAQ.what_is_resp.li_1_label_1'>
                  </a-link>
                  <span translate='FAQ.what_is_resp.li_1_2'></span>
                  <a-link link-url="FAQ.what_is_resp.li_1_link_2"
                        alt-text="FAQ.what_is_resp.li_1_alt_2"
                        label='FAQ.what_is_resp.li_1_label_2'>
                  </a-link>
                  <span translate='FAQ.what_is_resp.li_1_3'></span>
                  </li>
                  <li translate='FAQ.what_is_resp.li_2_1'>
                        <a-link link-url="FAQ.what_is_resp.li_2_link_1"
                              alt-text="FAQ.what_is_resp.li_2_alt_1"
                              label='FAQ.what_is_resp.li_2_label_1'>
                        </a-link>
                        <span translate='FAQ.what_is_resp.li_2_2'></span>
                        <a-link link-url="FAQ.what_is_resp.li_2_link_2"
                              alt-text="FAQ.what_is_resp.li_2_alt_2"
                              label='FAQ.what_is_resp.li_2_label_2'>
                        </a-link><span>.</span>
                 </li>
           </ul>
           <div class="page-title" translate='FAQ.what_is_resp.text_2'></div>
      </accordion>

      <accordion #acc_64 label="FAQ.why_use_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.why_use_resp.text_1'></div>
            <div class="page-title" translate='FAQ.why_use_resp.text_2'></div>
      </accordion>

      <accordion #acc_65 label="FAQ.ask_promoter.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.ask_promoter.text'></div>
      </accordion>

      <accordion #acc_66 label="FAQ.not_see_promoter.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.not_see_promoter.text_1'></div>
            <div class="page-title" translate='FAQ.not_see_promoter.text_2'>
                  <a-link link-url="FAQ.not_see_promoter.text_2_link"
                        alt-text="FAQ.not_see_promoter.text_2_alt"
                        label='FAQ.not_see_promoter.text_2_label'>
                  </a-link><span>.</span>
            </div>
      </accordion>

      <accordion #acc_67 label="FAQ.fees_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.fees_resp.text'></div>
      </accordion>

      <accordion #acc_68 label="FAQ.how_long_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.how_long_resp.text'></div>
      </accordion>

      <accordion #acc_69 label="FAQ.status_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.status_resp.text'></div>
      </accordion>

      <accordion #acc_70 label="FAQ.resp_promoters.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.resp_promoters.text'></div>
            <ul class="servie-list">
                  <li translate='FAQ.resp_promoters.li_1'></li>
                  <li translate='FAQ.resp_promoters.li_2'></li>
                  <li translate='FAQ.resp_promoters.li_3'></li>
                  <li translate='FAQ.resp_promoters.li_4'></li>
                  <li translate='FAQ.resp_promoters.li_5'></li>
            </ul>
      </accordion>

      <accordion #acc_71 label="FAQ.collecting_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.collecting_resp.text'></div>
      </accordion>

      <accordion #acc_72 label="FAQ.personal_information_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.personal_information_resp.text'></div>
      </accordion>

      <accordion #acc_73 label="FAQ.already_registered_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.already_registered_resp.text'>
                  <a-link link-url="FAQ.already_registered_resp.text_link"
                        alt-text="FAQ.already_registered_resp.text_alt"
                        label='FAQ.already_registered_resp.text_label'>
                  </a-link><span>.</span>
            </div>
      </accordion>

      <accordion #acc_74 label="FAQ.over_one_year_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.over_one_year_resp.text'>
                  <a-link link-url="FAQ.over_one_year_resp.text_link"
                        alt-text="FAQ.over_one_year_resp.text_alt"
                        label='FAQ.over_one_year_resp.text_label'>
                  </a-link><span>.</span>
            </div>
      </accordion>

      <accordion #acc_75 label="FAQ.still_use_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.still_use_resp.text_1'>
                  <a-link link-url="FAQ.still_use_resp.text_1_link"
                        alt-text="FAQ.still_use_resp.text_1_alt"
                        label='FAQ.still_use_resp.text_1_label'>
                  </a-link><span>. </span>
                  <span translate='FAQ.still_use_resp.text_2'></span>
            </div>
      </accordion>

      <accordion #acc_76 label="FAQ.what_happens_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.what_happens_resp.text_1'></div>
            <div class="page-title" translate='FAQ.what_happens_resp.text_2'></div>
            <div class="page-title" translate='FAQ.what_happens_resp.text_3'></div>
      </accordion>

      <accordion #acc_77 label="FAQ.dont_want_to_open_resp.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.dont_want_to_open_resp.text'></div>
      </accordion>

      <accordion #acc_78 label="FAQ.discussion_with_promoter.title"  outer-class="bottom-margin">
            <div class="page-title" translate='FAQ.discussion_with_promoter.text_1'></div>
            <div class="page-title" translate='FAQ.discussion_with_promoter.text_2'></div>
            <ol class="servie-list">
                  <li translate='FAQ.discussion_with_promoter.li_1'></li>
                  <li translate='FAQ.discussion_with_promoter.li_2'>
                  <ul class="servie-list" style="list-style: disc;">
                        <li translate='FAQ.discussion_with_promoter.li_2_li_1'></li>
                        <li translate='FAQ.discussion_with_promoter.li_2_li_2'></li>
                        <li translate='FAQ.discussion_with_promoter.li_2_li_3'></li>
                  </ul>
                  </li>
                  <li translate='FAQ.discussion_with_promoter.li_3'></li>
                  <li translate='FAQ.discussion_with_promoter.li_4'></li>
                  <li translate='FAQ.discussion_with_promoter.li_5'></li>
                  <li translate='FAQ.discussion_with_promoter.li_6'>
                        <ul class="servie-list" style="list-style: disc;">
                              <li translate='FAQ.discussion_with_promoter.li_6_li_1'></li>
                              <li translate='FAQ.discussion_with_promoter.li_6_li_2'></li>
                              <li translate='FAQ.discussion_with_promoter.li_6_li_3'></li>
                              <li translate='FAQ.discussion_with_promoter.li_6_li_4'></li>
                              <li translate='FAQ.discussion_with_promoter.li_6_li_5'></li>
                              <li translate='FAQ.discussion_with_promoter.li_6_li_6'></li>
                        </ul>
                </li>
            </ol>
      </accordion>
      </accordion>
      </div>
      <!--  ***** Education Savings Referral End ****  -->

     <!-- <div class="btn-div">
          <div><button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button></div>
     </div> -->

</div>
